import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs';
import { selectOrgSettings } from 'src/app/store/auth/auth.selector';
import { AutoUnsubscribeComponent } from 'src/app/utility/auto-unsubscribe.component';
import {
  isAppreciateEnabled,
  isNominationEnabled,
  isPostPollEnabled,
  isRewardEnabled,
} from 'src/app/utility/common-logic';
import { OrganizationSettings } from 'src/app/utility/model/organization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
})
export class TopMenuComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  orgSettings: OrganizationSettings;
  modules = environment.settings.modules;
  to: string;
  isShowAnnouncementEvents = environment.settings.isShowAnnouncementEvents;

  constructor(
    private store: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .pipe(select(selectOrgSettings), takeUntil(this.destroy$))
      .subscribe((settings) => {
        this.orgSettings = settings;
      });
    this.activatedRoute.url.subscribe((url: UrlSegment[]) => {
      this.to = url.length > 0 ? url[0].path : this.router.url.split('/')[1];
    });
  }

  get isCalendarEnabled() {
    return (
      !!this.orgSettings?.show_events || !!this.orgSettings?.show_greetings
    );
  }

  get showAppreciation() {
    return (
      isAppreciateEnabled(this.orgSettings) ||
      isNominationEnabled(this.orgSettings)
    );
  }

  get showFeeds() {
    return (
      isAppreciateEnabled(this.orgSettings) ||
      isPostPollEnabled(this.orgSettings)
    );
  }

  get showRewards() {
    return isRewardEnabled(this.orgSettings);
  }

  is(
    to:
      | 'home'
      | 'feeds'
      | 'rewards'
      | 'my-wallet'
      | 'calendar'
      | 'announcement'
      | 'event'
      | 'settings'
      | 'appreciate'
      | 'point-history',
  ) {
    return (
      (to === 'my-wallet' && to === this.router.url.split('/')[2]) ||
      (to === 'announcement' && to === this.router.url.split('/')[2]) ||
      (to === 'event' && to === this.router.url.split('/')[2]) ||
      (to === 'appreciate' && to === this.router.url.split('/')[1]) ||
      this.to === to
    );
  }

  selectedClass(
    to:
      | 'home'
      | 'feeds'
      | 'rewards'
      | 'my-wallet'
      | 'calendar'
      | 'announcement'
      | 'event'
      | 'settings'
      | 'appreciate'
      | 'point-history',
  ) {
    return this.is(to) ? 'selected' : '';
  }

  fontClass(to: string) {
    return this.to === to ? 'font-selected' : 'font-unselected';
  }

  onClickTopMenu(
    menu:
      | 'home'
      | 'feeds'
      | 'rewards'
      | 'my-wallet'
      | 'calendar'
      | 'announcement'
      | 'event'
      | 'settings'
      | 'appreciate'
      | 'point-history',
  ) {
    sessionStorage.setItem('selected-topMenu', menu);
    this.to = menu;
  }
}
